import { createQueryHook } from '@hooks/createQueryHook'

// Bet history. Component passes only { type, subType, source, status, page, pageSize }.
// Returns render-ready data: { rows, total, page, pageSize, pageCount } plus the
// TanStack flags { isPending, isError, error, refetch, ... }.
export const useBets = createQueryHook('bets.list')
